import React, { useState, useEffect, useRef } from 'react';

import { Dropdown, TextareaModal, FormGroupRadio, SubmenuTooltip, MoreButton, Button, formInput_funcUtility, FormInput_text, Datepicker, FormInput_textarea } from "components";

import { convertArrayToDropdownArrayFormat, func_validation, getObjectPropertyValue, isArrayNotEmpty, isBooleanFalseNotNullUndefined, getObjectPropertyValue_stringTrimNotEmpty, getObjectPropertyValue_validNumber, isNumberWithinRange, isStringTrimNotEmpty, func_currency, getRegexMatchCurrencyDoublePrecisionCaseInsensitive, isStringEqual_caseInsensitive, isNumberValid, isStringTrimEmpty, isNullUndefined, isDateValid, isNotNullUndefined, isDeepArrayComparisonEqual, isNotNull} from "functions";
import { FormCheckbox } from 'components/form/formCheckbox/FormCheckbox';
import { Toaster } from 'components/notification/Toaster';
import { chargeMethodList } from 'constants/lists';
import moment from 'moment';

export function useMultiProductInputs(props) {

    let { 
        isEditing,
        billingSetup,
        
        isFormSubmissionAttempted,
        
        fullProductCodeList: productCodeList,
        getFullProductDetailList_errorMsg,
        getFullProductDetail_requesting, fullProductDetail,
        
        // Functions
        getFullProductDetailList = () => {},
        getFullProductDetail = () => {}
    } = props;

    // States
    const [productList, setProductList] = useState([]);
    const [productList_init, setProductList_init] = useState();
    /*[
        {
            isDefaultProductDisabled: "", // for frontend use
            isDefaultProduct: "",
            productCode: "",
            productName: "",
            chargeMethod: "",
            unitPrice: "",
            unitDiscountAmount: "",
            quantity: "",
            transactionCountToCharge: "",
            posCountToCharge: "",
            referenceValuePlaceholder: "",
            referenceValue: "",
            lastBilledDateTime: "",
			nextBilledDateTime: "",
			cutOffDate: "",
			lastBilledDateDay: "",
			systemChargeMethodComment: "",
        }
    ]*/
    const [isAnyInputChanged, setIsAnyInputChanged] = useState(false);
    const [isReferenceValueModalVisible, setIsReferenceValueModalVisible] = useState(false);

    const [isComponentMounted, setIsComponentMounted] = useState(false);
    
    const [updateProductIndex, setupdateProductIndex] = useState(0); // save index when to update value from getFullProductDetail

    useEffect(() => { setIsComponentMounted(true); }, []);

    useEffect(() => {
        if(isEditing && isNotNullUndefined(billingSetup)) {
            let isDefaultProduct_init = getObjectPropertyValue(billingSetup, "IsDefaultProduct", false);
            let isDefaultProductDisabled_init = (billingSetup?.ChargeMethod === "System")

            let productCode_original = getObjectPropertyValue(billingSetup, "ProductCode");
            let productName_original = getObjectPropertyValue(billingSetup, "ProductName");
            let chargeMethod_init = getObjectPropertyValue_stringTrimNotEmpty(billingSetup, "ChargeMethod", "Outlet Transaction");
            chargeMethod_init = chargeMethodList.find((obj) => obj?.label === chargeMethod_init)?.value;
            let unitPrice_init = getObjectPropertyValue_validNumber(billingSetup, "UnitPrice", "0.00") + "";
            unitPrice_init = func_currency.validateStringDoublePrecisionCurrency(unitPrice_init, '0.00');
            let unitDiscountAmount_init = getObjectPropertyValue_validNumber(billingSetup, "UnitDiscountAmount", "0.00") + "";
            unitDiscountAmount_init = func_currency.validateStringDoublePrecisionCurrency(unitDiscountAmount_init, '0.00');
            let quantity_init = getObjectPropertyValue_validNumber(billingSetup, "Quantity", 0);
            let transactionCountToCharge_init = getObjectPropertyValue_validNumber(billingSetup, "TransactionCountToCharge", "");
            let posCountToCharge_init = getObjectPropertyValue_validNumber(billingSetup, "POSCountToCharge", 0);
            
            let billingSetupDetails = func_validation.getObjectPropertyValue(billingSetup, "BillingSetupDetails");
            let referenceValue_original = "";
            if (func_validation.isArrayNotEmpty(billingSetupDetails)) {
                billingSetupDetails.map((detail, idx) => {
                    let referenceValue = func_validation.getObjectPropertyValue(detail, "ReferenceValue");
                    if (referenceValue_original == "") {
                        referenceValue_original = referenceValue + "\n";
                    }
                    else {
                        referenceValue_original += referenceValue + "\n";
                    }
                });
            }
            let referenceValue_init = func_validation.isNotNullUndefined(referenceValue_original)? referenceValue_original: "";

            let referenceValuePlaceholder_init = "";
            if (func_validation.isStringTrimNotEmpty(referenceValue_init)) {
                let totalReferenceValues = referenceValue_init.trim().split("\n").length;
                referenceValuePlaceholder_init = totalReferenceValues + " value(s)";
            }

            let currentDate_toString = moment().format("YYYY-MM-DD");
            let lastBilledDateTime_init = getObjectPropertyValue_stringTrimNotEmpty(billingSetup, "LastBilledDateTime", currentDate_toString);
            let nextBilledDateTime_init = getObjectPropertyValue_stringTrimNotEmpty(billingSetup, "NextBilledDateTime", currentDate_toString);
            let lastBilledDateDay_init = getObjectPropertyValue_validNumber(billingSetup, "LastBilledDateDay");
            let firstDayOfTodaysMonth = moment().date(1);
            let cutOffDate_init = getObjectPropertyValue_stringTrimNotEmpty(billingSetup, "CutOffDate", firstDayOfTodaysMonth.format("YYYY-MM-DD"));
            if (isDateValid(cutOffDate_init)) cutOffDate_init = moment(cutOffDate_init).date(1).format("YYYY-MMM-DD");
            let systemChargeMethodComment_init = getObjectPropertyValue_stringTrimNotEmpty(billingSetup, "SystemChargeMethodComment", "");

            let editProductObj = {
                isDefaultProductDisabled: isDefaultProductDisabled_init,
                isDefaultProduct: isDefaultProduct_init,
                productCode: productCode_original,
                productName: productName_original,
                chargeMethod: chargeMethod_init,
                unitPrice: unitPrice_init,
                unitDiscountAmount: unitDiscountAmount_init,
                quantity: quantity_init,
                transactionCountToCharge: transactionCountToCharge_init,
                posCountToCharge: posCountToCharge_init,
                referenceValuePlaceholder: referenceValuePlaceholder_init,
                referenceValue: referenceValue_init,
                lastBilledDateTime: lastBilledDateTime_init,
                nextBilledDateTime: nextBilledDateTime_init,
                cutOffDate: cutOffDate_init,
                lastBilledDateDay: lastBilledDateDay_init,
                systemChargeMethodComment: systemChargeMethodComment_init,
            }

            setProductList([{...editProductObj}])
            setProductList_init({...editProductObj})
        }
    }, [billingSetup])

    // Check for changes in input from initial
    useEffect(() => {
        
        let isNotChangedFromOriginal = (
            isDeepArrayComparisonEqual(productList, productList_init)
        );

        let isChangedFromEmpty = (
            isArrayNotEmpty(productList) || isNotNullUndefined(productList)
        );

        setIsAnyInputChanged(isEditing? !isNotChangedFromOriginal: isChangedFromEmpty);
    }, [
        productList
    ]);

    // Get full list
    useEffect(() => {
        getFullProductDetailList();
    }, []);

    let productCodeList_formatted = [];
    if (isArrayNotEmpty(productCodeList)) {
        productCodeList_formatted = productCodeList.map((obj) => {
            return {
                label: obj?.ProductCode,
                value: obj?.ProductCode
            }
        })
    }

    // Auto input charge method and unit price if available 
    useEffect(() => {
        if(!getFullProductDetail_requesting && isArrayNotEmpty(fullProductDetail)) {
            if(fullProductDetail.length === 1) {
                let chargeMethod = fullProductDetail[0]?.ChargeMethod
                let unitPrice = fullProductDetail[0]?.UnitPrice.toString();
                let transactionCountToCharge = (chargeMethod === chargeMethodList[1].value || chargeMethod === chargeMethodList[2].value)? 1:0
                let posCountToCharge = (chargeMethod === chargeMethodList[2].value)? 2:0
                handleMultiInputChange(updateProductIndex, {
                    "chargeMethod": chargeMethod,
                    "unitPrice": unitPrice,
                    "transactionCountToCharge": transactionCountToCharge,
                    "posCountToCharge": posCountToCharge,
                })
            }
            else {
                let productDetails = fullProductDetail.map(({ ProductCode, ProductName, ChargeMethod, UnitPrice }) => ({
                    productCode: ProductCode,
                    productName: ProductName,
                    chargeMethod: ChargeMethod,
                    unitPrice: UnitPrice.toString(),
                    isDefaultProduct: true,
                    unitDiscountAmount: 0,
                    quantity: 0,
                    lastBilledDateTime: moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
                    nextBilledDateTime: moment().endOf("month").format("YYYY-MM-DD"),
                    cutOffDate: moment().subtract(1, "year").startOf("year").format("YYYY-MM-DD"),
                    lastBilledDateDay: 31,
                    transactionCountToCharge: 
                        (ChargeMethod === chargeMethodList[1].value || ChargeMethod === chargeMethodList[2].value)? 1:0,
                    posCountToCharge:
                        (ChargeMethod === chargeMethodList[2].value)? 2:0,
                    systemChargeMethodComment: ""
                }));

                multiAddProduct(productDetails)
            }
        }
    }, [getFullProductDetail_requesting])

    // Function to add a new multi product input
    const multiAddProduct = (newProduct) => {
        setProductList([...productList, ...newProduct])
    }

    // Function to add a new product input
    const addProduct = (newProduct) => {
        setProductList([...productList, { ...newProduct}])
    }

    // Function to remove a product input by index
    const removeProduct = (index) => {
        setProductList(prodList => prodList.filter((_, i) => i !== index));
    };

    const handleInputChange = (index, key, value) => {
        // Create a shallow copy of the productList array
        const updatedList = [...productList];
        
        // Update the specific property of the product at the given index
        updatedList[index] = {
            ...updatedList[index],
            [key]: value
        };

        // Update the state with the modified list
        setProductList(updatedList);
    }

    // example: multiValue = { transactionCountToCharge: 0, posCountToCharge: 1  }
    const handleMultiInputChange = (index, multiValue) => {
        // Create a shallow copy of the productList array
        const updatedList = [...productList];
        
        // Update the specific property of the product at the given index
        updatedList[index] = {
            ...updatedList[index],
            ...multiValue
        };

        // Update the state with the modified list
        setProductList(updatedList);
    }

    function referenceValue_onConfirm(index, value) {
        if (isStringTrimNotEmpty(value)) {
            let valueArray = value.trim().split("\n");
            let totalValues = 0;

            if (isArrayNotEmpty(valueArray)) {
                let arraySize = valueArray.length;
                for (let i = 0; i < arraySize; i++) {
                    let referenceValue = valueArray[i];

                    if (isStringTrimNotEmpty(referenceValue))
                        totalValues++;
                }
            }
            handleMultiInputChange(index, {
                "referenceValuePlaceholder": totalValues + " value(s)",
                "referenceValue": value
            })
        }
        else {
            handleMultiInputChange(index, {
                "referenceValuePlaceholder": "",
                "referenceValue": ""
            })
        }
    }

    function referenceValue_updateStates(index) {
        if (!productList[index]?.isDefaultProduct && isComponentMounted &&
            isStringTrimNotEmpty(productList[index]?.referenceValue) &&
            !(productList[index]?.ChargeMethod === "System")) {
            handleMultiInputChange(index, {
                "referenceValuePlaceholder": "",
                "referenceValue": ""
            })
        }
    }

    // useRef to store the previous isDefaultProduct values
    const prevIsDefaultProductList = useRef(productList.map(p => p.isDefaultProduct));
    useEffect(() => {
        const currentIsDefaultProductList = productList.map(p => p.isDefaultProduct);
        // Find the index of the changed product(s)
        const changedIndices = currentIsDefaultProductList.reduce((acc, value, index) => {
        if (value !== prevIsDefaultProductList.current[index]) {
            acc.push(index);
        }
        return acc;
        }, []);

        if (changedIndices.length > 0) {
            // Call your update function
            referenceValue_updateStates(changedIndices);
        }

        // Update the previous state to current
        prevIsDefaultProductList.current = currentIsDefaultProductList;
    }, [productList]);

    function posCountToCharge_updateStates(index) {
        if (!isStringEqual_caseInsensitive(productList[index]?.chargeMethod, "OutletPos") &&
            (productList[index]?.posCountToCharge != 0)) {

            handleInputChange(index, "posCountToCharge", 0);
        }
    }
    function systemChargeMethodComment_updateStates(index) {
        if (isStringTrimNotEmpty(productList[index]?.systemChargeMethodComment)) {

            handleInputChange(index, "systemChargeMethodComment", "")
        }
    }
    function systemChargeMethod_updateReferenceValue(index) {
        if (isStringEqual_caseInsensitive(productList[index]?.chargeMethod, "System")) {

            handleMultiInputChange(index, {
                "referenceValue": "System",
                "referenceValuePlaceholder": "1 value(s)",
                "isDefaultProduct": false,
                "isDefaultProductDisabled": true
            })
        }
        else if (productList[index]?.referenceValue === "System") {
            handleMultiInputChange(index, {
                "referenceValue": "",
                "referenceValuePlaceholder": "",
                "isDefaultProductDisabled": false
            })
        }
        else {
            handleInputChange(index, "isDefaultProductDisabled", false)
        }
    }

    // useRef to store the previous chargeMethod values
    const prevChargeMethodProductList = useRef(productList.map(p => p.chargeMethod));
    useEffect(() => {
        const currentChargeMethodProductList = productList.map(p => p.chargeMethod);
        // Find the index of the changed product(s)
        const changedIndices = currentChargeMethodProductList.reduce((acc, value, index) => {
        if (value !== prevChargeMethodProductList.current[index]) {
            acc.push(index);
        }
        return acc;
        }, []);

        if (changedIndices.length > 0) {
            // Call your update function
            if(isComponentMounted) {
                posCountToCharge_updateStates(changedIndices);
                systemChargeMethodComment_updateStates(changedIndices);
                systemChargeMethod_updateReferenceValue(changedIndices);
            }
        }

        // Update the previous state to current
        prevChargeMethodProductList.current = currentChargeMethodProductList;
    }, [productList]);

    // List of number from 1 - 31 inclusive
    let lastBilledDateDay_options = [];
    for (let i = 1; i < 32; i++) {
        lastBilledDateDay_options.push(i);
    }

    // Display
    let display = (
        <div className={"recursiveBillingSetupAccountUpdate-multi-product"}>
            {productList && productList.map((product, index) => (
                <div key={index} className={"recursiveBillingSetupAccountUpdate-product d-flex flex-wrap"}>
                    {/* Is Default Product */}
                    <div className={"col-6 side-inputs__is-default-product " +
                        (isFormSubmissionAttempted? "side-inputs__is-default-product_error ":"")}
                    >
                        <FormCheckbox
                            checkboxClassName={"is-default-product__checkbox"}
                            checkboxIconClassName={"checkbox__icon"}
                            handleCheckboxSelectionSub={(checkboxId, isChecked) => {
                                handleInputChange(index, "isDefaultProduct", isChecked)
                            }}
                            isCheckboxCheckedDefault={product?.isDefaultProduct}
                            isCheckboxDisabled={product?.isDefaultProductDisabled}

                            checkboxWrapperClassName={"d-flex"}
                            checkboxLabel={"Set as default product"}

                            isFormSubmissionAttempted={isFormSubmissionAttempted}
                            errorMsg={
                                (product?.isDefaultProduct && isStringTrimNotEmpty(product?.referenceValue))? "Default product cannot have reference value":
                                    (!product?.isDefaultProduct && isStringTrimEmpty(product?.referenceValue))? "Non-default product must have reference value":
                                        (isStringEqual_caseInsensitive(product?.chargeMethod, "System") && product?.isDefaultProduct)? "Default product cannot have 'System' as charge method":""}
                        />
                    </div>

                    <div className='d-flex justify-content-end col-6'>
                        <SubmenuTooltip
                            buttonClassName={"recursiveBillingSetupAccountUpdate-moreActionsWrapper"}
                            menuItems={
                                [
                                    {
                                        label: "Delete",
                                        onClick: () => removeProduct(index),
                                    },
                                    {
                                        label: "Duplicate",
                                        onClick: () => {
                                            addProduct({...productList[index]}) 
                                        },
                                    },
                                ]
                            }
                        >
                            <MoreButton
                                iconClassName={"recursiveBillingSetupAccountUpdate-moreActionsWrapper-icon"}
                            />
                        </SubmenuTooltip>
                    </div>

                    {/* Product Code */}
                    <Dropdown
                        className={"recursiveBillingSetupAccountUpdate-productCode col-3"}
                        label={"Product Code"}
                        isInputRequired
        
                        selectedValueClassName={"recursiveBillingSetupAccountUpdate-productCode-input"}
        
                        options={productCodeList_formatted}
                        selectedValue_default={product?.productCode}
                        valueFromParent={product?.productCode}
                        onChange={(value) => {
                            handleInputChange(index, "productCode", value)
                        }}
                        onBlur={(value) => {
                            if (isArrayNotEmpty(productCodeList)) {
                                let isMatchFound = false;
                                productCodeList.map((obj) => {
                                    if (value === obj?.ProductCode) {
                                        handleInputChange(index, "productName", obj?.ProductName)
                                        isMatchFound = true;

                                        // Get product details when product code change
                                        getFullProductDetail(value)
                                        setupdateProductIndex(index)
                                    }
                                });
        
                                if (!isMatchFound) {
                                    handleInputChange(index, "productName", "")
        
                                    Toaster({
                                        type: "info",
                                        msg: "Product code must match option from the dropdown list",
                                        timer: 10000
                                    })
                                }
                            }
                        }}
        
                        errorMsg={"Required"}
        
                        isFormSubmissionAttempted={isFormSubmissionAttempted}
                        isSearchable
                        isDisabled={isEditing}
                    />
        
                    {/* Product Name */}
                    <Dropdown
                        className={"recursiveBillingSetupAccountUpdate-productName col-3"}
                        label={"Product Name"}
                        isInputRequired
        
                        selectedValueClassName={"recursiveBillingSetupAccountUpdate-productName-input"}
        
                        // options={productNameList}
                        selectedValue_default={product?.productName}
                        valueFromParent={product?.productName}
                        onChange={(value) => {
                            handleInputChange(index, "productName", value)
                        }}
        
                        errorMsg={"Required"}
        
                        isFormSubmissionAttempted={isFormSubmissionAttempted}
                        isSearchable
                        isDisabled={!getFullProductDetailList_errorMsg || isEditing} // allow user to edit this input if list fails to load 
                    />

                    {/* Charge Method */}
                    <Dropdown
                        className={"recursiveBillingSetupAccountUpdate-chargeMethod col-3"}
                        label={"Charge Method"}
                        isInputRequired

                        selectedValueClassName={"recursiveBillingSetupAccountUpdate-chargeMethod-input"}

                        options={chargeMethodList}
                        selectedValue_default={product?.chargeMethod}
                        valueFromParent={product?.chargeMethod}
                        onChange={(value) => {
                            let chargeMethod = value;
                            let transactionCountToCharge = 0;
                            let posCountToCharge = 0;

                            if(value === chargeMethodList[1].value || value === chargeMethodList[2].value) {
                                transactionCountToCharge = 1;
                            }

                            if(value === chargeMethodList[2].value) {
                                posCountToCharge = 2;
                            }

                            handleMultiInputChange(index, { chargeMethod, transactionCountToCharge, posCountToCharge })
                        }}

                        errorMsg={(isStringTrimEmpty(product?.chargeMethod) || isNullUndefined(product?.chargeMethod))? "Required":
                                        (product?.chargeMethod === "System" && product?.isDefaultProduct)? "System cannot be set as default product":
                                            (product?.chargeMethod === "OutletPos" && !isNumberWithinRange(product?.posCountToCharge, { min: 1 }))? "Outlet Pos must have a value greater than 0 for 'POS count to charge'":
                                                (product?.chargeMethod === "OutletTransaction" && !isNumberValid(product?.transactionCountToCharge)? "Outlet Transaction must have a value for 'transaction count to charge'":
                                                    "")}
                        customErrorValidation={isFormSubmissionAttempted && 
                            (isStringTrimEmpty(product?.chargeMethod) || isNullUndefined(product?.chargeMethod) ||
                            (product?.chargeMethod === "System" && product?.isDefaultProduct) ||
                            (product?.chargeMethod === "OutletPos" && !isNumberValid(product?.posCountToCharge)) ||
                            (product?.chargeMethod === "OutletTransaction" && !isNumberValid(product?.transactionCountToCharge)))}
                        isFormSubmissionAttempted={isFormSubmissionAttempted}

                        isDisabled={isEditing}

                        isSearchable isSortingOptional
                    />

                    {/* Unit Price */}
                    <FormInput_text  
                        inputLabel={"Unit Price (RM)"}

                        className={"recursiveBillingSetupAccountUpdate-unitPrice col-3"}
                        inputValue_default={product?.unitPrice} 
                        inputValue={product?.unitPrice}

                        handleInputBlurExtend={(value) => { 
                            if (isStringTrimNotEmpty(value)) handleInputChange(index, "unitPrice", value);
                            else handleInputChange(index, "unitPrice", "");
                        }}

                        inputMaxLength={64} 

                        customErrorMsgDefault={"Required"}
                        isFormSubmissionAttempted={isFormSubmissionAttempted} 

                        handleInputFocusExtend={(e)=>{ formInput_funcUtility.handleInputFocus_onEnter_selectInput(e); }}
                        isValuePropagationGuarded_onChange={(value)=>{ return (value.match(getRegexMatchCurrencyDoublePrecisionCaseInsensitive()) || value == '') }}
                        customValidator_onBlur={(value)=>{ return func_currency.validateStringDoublePrecisionCurrency(value, '0.00'); }}

                        isInputValueTrim_onChange 
                        isInputBlurHandlingRequired isInputValueTrim_onBlur
                        isMarginBtmOptional

                        isInputDisabled={isEditing}
                    />

                    {/* Unit Discount Amount */}
                    <FormInput_text  
                        inputLabel={"Unit Discount Amount (RM)"}
                        isInputOptional

                        className={"recursiveBillingSetupAccountUpdate-unitDiscountAmount col-3"}
                        inputValue_default={product?.unitDiscountAmount}
                        inputValue={product?.unitDiscountAmount}

                        handleInputBlurExtend={(value) => { handleInputChange(index, "unitDiscountAmount", value); }}

                        inputMaxLength={64} 

                        handleInputFocusExtend={(e)=>{ formInput_funcUtility.handleInputFocus_onEnter_selectInput(e); }}
                        isValuePropagationGuarded_onChange={(value)=>{ return (value.match(getRegexMatchCurrencyDoublePrecisionCaseInsensitive()) || value == '') }}
                        customValidator_onBlur={(value)=>{ return func_currency.validateStringDoublePrecisionCurrency(value, '0.00'); }}

                        isInputValueTrim_onChange
                        isInputBlurHandlingRequired isInputValueTrim_onBlur
                        isMarginBtmOptional isErrorMsgOptional

                        isInputDisabled={isEditing}
                    />

                    {/* Quantity */}
                    <FormInput_text  
                        inputLabel={"Quantity"}

                        className={"recursiveBillingSetupAccountUpdate-quantity col-3"}
                        inputValue_default={product?.quantity} 
                        inputValue={product?.quantity}

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { handleInputChange(index, "quantity", value); }}

                        inputMaxLength={64}

                        customErrorMsgDefault={"Required"}
                        isFormSubmissionAttempted={isFormSubmissionAttempted}

                        isInputValueTrim_onChange
                        isMarginBtmOptional isInputDigitOnly isConvertedToNumber

                        isInputDisabled={isEditing}
                    />

                    {/* Transaction Count to Charge */}
                    <FormInput_text
                        inputLabel={"Transaction Count to Charge"}
                        isInputOptional={!isStringEqual_caseInsensitive(product?.chargeMethod, "OutletTransaction")}

                        className={"recursiveBillingSetupAccountUpdate-transactionCountToCharge col-6"}
                        inputValue={product?.transactionCountToCharge} 

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { 
                            handleInputChange(index, "transactionCountToCharge", value);
                        }}

                        inputMaxLength={64} 

                        customErrorMsgDefault={"Required"}
                        customErrorValidation={isStringEqual_caseInsensitive(product?.chargeMethod, "OutletTransaction") &&
                            (!isNumberValid(product?.transactionCountToCharge)) &&
                            isFormSubmissionAttempted}

                        isInputValueTrim_onChange
                        isMarginBtmOptional isInputDigitOnly isConvertedToNumber

                        isInputDisabled={isEditing}
                    />

                    {/* POS Count To Charge */}
                    <FormInput_text  
                        inputLabel={"POS Count to Charge"}
                        isInputOptional={!isStringEqual_caseInsensitive(product?.chargeMethod, "OutletPos")}

                        className={"recursiveBillingSetupAccountUpdate-posCountToCharge col-3"}
                        inputValue={product?.posCountToCharge}

                        handleInputClickExtend={() => {
                            if (!isStringEqual_caseInsensitive(product?.chargeMethod, "OutletPos"))
                                Toaster({
                                    type: "info",
                                    msg: "Please set Charge Method input as Outlet POS."
                                });
                        }}
                        isInputClickHandlingRequired

                        handleInputBlurExtend={(value) => { handleInputChange(index, "posCountToCharge", value); }}
                        isInputBlurHandlingRequired

                        inputMaxLength={64}

                        customErrorMsgDefault={"Input required to be greater than 0"}
                        customErrorValidation={isStringEqual_caseInsensitive(product?.chargeMethod, "OutletPos") &&
                            (!isNumberWithinRange(product?.posCountToCharge, { min: 1 })) &&
                            isFormSubmissionAttempted}

                        isInputValueTrim_onChange
                        isMarginBtmOptional isInputDigitOnly isConvertedToNumber
                        isInputDisabled={!isStringEqual_caseInsensitive(product?.chargeMethod, "OutletPos") || isEditing}
                        // inputCustomOptions={{ readOnly: (!isStringEqual_caseInsensitive(product?.chargeMethod, "OutletPos")) }}
                    />

                    {/* Reference Value */}
                    <FormInput_text
                        className={"recursiveBillingSetupAccountUpdate-referenceValues col-3"}
                        customInputClassName={"recursiveBillingSetupAccountUpdate-referenceValues-input"}
                        inputValue={product?.referenceValuePlaceholder}

                        inputLabel={"Reference Value(s)"}
                        isInputOptional

                        handleInputClickExtend={() => {
                            if (product?.ChargeMethod === "System") {
                                Toaster({
                                    type: "info",
                                    msg: "Charge Method cannot be 'System'"
                                });
                            }
                            else {
                                product?.isDefaultProduct? 
                                    Toaster({
                                        type: "info",
                                        msg: "Please set Default Product as false."
                                    })
                                :setIsReferenceValueModalVisible(true); 
                            }
                        }}
                        isInputClickHandlingRequired

                        customErrorMsg={"Required"}
                        customErrorValidation={
                            isFormSubmissionAttempted && 
                            (isBooleanFalseNotNullUndefined(product?.isDefaultProduct) && 
                            isStringTrimEmpty(product?.referenceValue)
                        )}

                        isMarginBtmOptional
                        isInputDisabled={isStringEqual_caseInsensitive(product?.ChargeMethod, "System") || product?.isDefaultProduct}
                        inputCustomOptions={{ readOnly: true }}
                    />
                    <TextareaModal
                        title={"Reference Value(s)"}

                        inputValue={product?.referenceValue}
                        placeholder={"Enter one reference value per line"}
                        confirmButtonText={"Save"}

                        isModalVisible={isReferenceValueModalVisible}
                        updateParentState={setIsReferenceValueModalVisible}

                        handleOnConfirm={(value) => { 
                            referenceValue_onConfirm(index, value);
                            setIsReferenceValueModalVisible(false);
                        }}
                    />

                    {/* Last Billed Date */}
                    <Datepicker
                        className={"recursiveBillingSetupAccountUpdate-lastBilledDate col-3"}
                        inputClassName={"recursiveBillingSetupAccountUpdate-lastBilledDate-input"}
                        
                        label={"Last Billed Date"}
                        defaultDate={product?.lastBilledDateTime}
                        dateFromParent={product?.lastBilledDateTime}
                        handleOnChange={(value) => {
                            handleInputChange(index, "lastBilledDateTime", value);
                        }}

                        isFormSubmissionAttempted={isFormSubmissionAttempted}
                        errorMsg={"Required"}

                        isConversionRequired_ISO8601 isInputRequired
                    />

                    {/* Next Billed Date */}
                    <Datepicker
                        className={"recursiveBillingSetupAccountUpdate-nextBilledDate col-3"}
                        inputClassName={"recursiveBillingSetupAccountUpdate-nextBilledDate-input"}

                        label={"Next Billed Date"}
                        defaultDate={product?.nextBilledDateTime}
                        dateFromParent={product?.nextBilledDateTime}
                        handleOnChange={(value) => {
                            handleInputChange(index, "nextBilledDateTime", value);
                        }}

                        isFormSubmissionAttempted={isFormSubmissionAttempted}
                        errorMsg={"Required"}

                        isConversionRequired_ISO8601 isInputRequired
                    /> 

                    {/* Cut Off Date */}
                    <Datepicker
                        className={"recursiveBillingSetupAccountUpdate-cutOffDate col-3"}
                        inputClassName={"recursiveBillingSetupAccountUpdate-cutOffDate-input"}
                        
                        label={"Cut Off Date"}
                        defaultDate={product?.cutOffDate}
                        dateFromParent={product?.cutOffDate}
                        dateFormat={"MM/yyyy"}
                        handleOnChange={(value) => {
                            handleInputChange(index, "cutOffDate", value);
                        }}

                        isFormSubmissionAttempted={isFormSubmissionAttempted}
                        errorMsg={"Required"}

                        isConversionRequired_ISO8601 isMonthYear
                    />

                    {/* Last Billed Date Day */}
                    <Dropdown
                        className={"recursiveBillingSetupAccountUpdate-lastBilledDateDay col-3"}
                        label={"Last Billed Date Day"}
                        isInputRequired

                        selectedValueClassName={"recursiveBillingSetupAccountUpdate-lastBilledDateDay-input"}

                        options={convertArrayToDropdownArrayFormat(lastBilledDateDay_options)}
                        selectedValue_default={product?.lastBilledDateDay}
                        valueFromParent={product?.lastBilledDateDay}
                        onChange={(value) => {
                            handleInputChange(index, "lastBilledDateDay", value);
                        }}

                        errorMsg={"Required"}
                        isFormSubmissionAttempted={isFormSubmissionAttempted}

                        minInputDigit={1}
                        minInputDigit_invalidMsg={"Last Billed Date Day must be between 1 and 31 inclusive"}
                        isInputDigitOnly

                        isSearchable
                        isInputValueTrim_onChange isOptionPosition_up
                    />

                    {/* System Charge Method Comment */}
                    <FormInput_textarea
                        inputLabel={"System Charge Method Comment"}
                        isInputOptional

                        className={"recursiveBillingSetupAccountUpdate-systemChargeMethodComment col-6"}
                        customInputClassName={"recursiveBillingSetupAccountUpdate-systemChargeMethodComment-input"}
                        inputValue={product?.systemChargeMethodComment}

                        handleInputBlurExtend={(value) => { handleInputChange(index, "systemChargeMethodComment", value); }}
                        isInputBlurHandlingRequired

                        isInputValueTrim_onChange isMarginBtmOptional isErrorMsgOptional
                        isInputDisabled={isEditing}
                    />
                </div>
            ))}
            {!isEditing && (
                <div className='input-wrapper__footer'>
                    <div className='px-2'>
                        <Button
                            className={"commitment-pay-setup__invoices-footer__cancel-button"}
                            handleOnClick={() => {
                                addProduct({
                                    productCode: "",
                                    productName: "",
                                    isDefaultProduct: true,
                                    unitDiscountAmount: 0,
                                    quantity: 0,
                                    lastBilledDateTime: moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
                                    nextBilledDateTime: moment().endOf("month").format("YYYY-MM-DD"),
                                    cutOffDate: moment().subtract(1, "year").startOf("year").format("YYYY-MM-DD"),
                                    lastBilledDateDay: 31,
                                    transactionCountToCharge: 0,
                                    systemChargeMethodComment: ""
                                })
                            }}
                        >
                            Add Product
                        </Button>
                    </div>
                    <div className='px-2'>
                        <Button
                            className={"commitment-pay-setup__invoices-footer__save-button"}
                            handleOnClick={() => getFullProductDetail()}
                        >
                            Add All Product
                        </Button>
                    </div>
                </div>
            )}
        </div>    
    );

    function isChargeMethodValid(product) {
        return (isStringTrimNotEmpty(product?.chargeMethod) &&
        ((isStringEqual_caseInsensitive(product?.chargeMethod, "OutletTransaction") && isNumberValid(product?.transactionCountToCharge)) || 
            (!isStringEqual_caseInsensitive(product?.chargeMethod, "OutletTransaction"))) &&
        ((isStringEqual_caseInsensitive(product?.chargeMethod, "OutletPos") && isNumberValid(product?.posCountToCharge)) || 
            (!isStringEqual_caseInsensitive(product?.chargeMethod, "OutletPos"))) &&
        ((isStringEqual_caseInsensitive(product?.chargeMethod, "System") && !product?.isDefaultProduct && (product?.referenceValue === "System")) ||
            (!isStringEqual_caseInsensitive(product?.chargeMethod, "System"))));
    }

    const checkIsEveryInputValid = () => {
        let isEveryInputValid = true;
        for(let i = 0; i < productList.length; i++) {
            if(
                isStringTrimNotEmpty(productList[i]?.productCode) &&
                isStringTrimNotEmpty(productList[i]?.productName) &&
                isChargeMethodValid(productList[i]) &&
                isStringTrimNotEmpty(productList[i]?.unitPrice) &&
                // isNumberValid(productList[i]?.quantity) &&
                // isStringTrimNotEmpty(productList[i]?.unitDiscountAmount)
                isDateValid(productList[i]?.lastBilledDateTime) &&
                isDateValid(productList[i]?.nextBilledDateTime) &&
                // isStringTrimNotEmpty(productList[i]?.cutOffDate) &&
                isNumberValid(productList[i]?.lastBilledDateDay)
            ) {
                isEveryInputValid = true;
            }
            else {
                isEveryInputValid = false;
                break;
            }
        }

        return isEveryInputValid
    }

    let isEveryInputValid = (
        checkIsEveryInputValid()
    );

    return {
        isEveryInputValid,
        isAnyInputChanged,
        productList,
        display
    }
}